import { createContext } from 'react';
import { TaxpayerContext } from '../models/Elements';
import { Taxpayer } from '../models/Entities';

const CustomTaxpayerContext = createContext<TaxpayerContext>({
    taxpayer: {},
    setTaxpayer: (taxpayer: Taxpayer) => {}
});
export default CustomTaxpayerContext;
